import React, { Component } from 'react';
import { Button } from 'semantic-ui-react';
import * as esriLoader from 'esri-loader';
import BuildingsFilterComponent from './BuildingsFilterComponent';

export default class EsriMap extends Component {

  filterState = {};

  render() {
    const { active } = this.filterState;
    const theWebPage = this.renderPage();
    const theMap = this.renderMap();

    return (
      <div className="App">
        {theWebPage}
        <div id="mapDiv" className="App-mapDiv"></div>
        <div id="widgetDiv" className="App-widgetDiv"><BuildingsFilterComponent /></div>
        <div id="widgetButton" className="App-widgetButton">
          <Button icon="filter" toggle active={active}
                  onClick={this.handleFilterState.bind(this)}></Button>
          {theMap}
        </div>
      </div>
    );
  }

  handleFilterState(event, data) {
    this.setState({ active: !this.filterState.active })
    var x = document.getElementById("widgetDiv");
    if (x.style.display === "none") {
        x.style.display = "block";
    } else {
        x.style.display = "none";
    }
  }

  renderPage () {
    return (
      <div>
        <table border="0" bgcolor="#000000" width="100%">
        <tr>
          <td valign="middle" width="75">
            &nbsp;
            <a href='http://www.nyc.gov/landmarks' target="_blank">
              <img src='nyclpc.png' width="55px" height="30px" style={{"margin-top": '5px'}} />
            </a>
        </td>
        <td width="400">
          <span style={{'color': 'white', 'font-size': '140%;'}}>
            &nbsp;Discover New York City Landmarks&nbsp;
          </span>
        </td>
        <td align="left">
          <a target="_blank" href='https://nyclpc.maps.arcgis.com/apps/GeoForm/index.html?appid=8cb01c0e84d24ebebde44dd8d5f66478'>
            <span style={{'color': 'gray'}}>Data and Map Feedback</span>
          </a>
        </td>
        <td align="right">
          <img width="25px" height="25px" src='https://nyclpc.maps.arcgis.com/sharing/rest/content/items/93a88691cace4067828b1eede432022b/resources/inConfig/5112830979602649.png' />&nbsp;
          <img width="25px" height="25px" src='https://nyclpc.maps.arcgis.com/sharing/rest/content/items/93a88691cace4067828b1eede432022b/resources/inConfig/5772891006942753.png' />&nbsp;
          <img width="25px" height="25px" src='https://nyclpc.maps.arcgis.com/sharing/rest/content/items/93a88691cace4067828b1eede432022b/resources/inConfig/3573133395234016.png' />&nbsp;
        </td>
      </tr>
      </table>
      </div>
    )
  }

  renderMap () {
    window.globalESRIoption = {url: 'https://js.arcgis.com/3.24/'};

    esriLoader.loadModules(["esri/map", "esri/arcgis/utils"], window.globalESRIoption)
      .then(([Map, arcgisUtils]) => {

        esriLoader.loadCss('https://js.arcgis.com/3.24/esri/css/esri.css');
        arcgisUtils.createMap("2d2aa4fd22fc4761903e6bfd39ee63bc", "mapDiv").then(function (response) {
          window.globalMap = response.map;
  //fa1bcaad31374a88839da3f0166e640a
          //a38d198df9bc469a8b452d416dd90328
        })

      }
    )
  }

}
